import { useContext } from 'react';
import { DialogContext } from 'src/context/DialogContext';

export const useDialog = () => {
  const { openDialog, closeDialog } = useContext(DialogContext);

  return { openDialog, closeDialog };
};
